{
  "signUpFree": "Regístrate gratis",
  "firstName": "Nombre",
  "lastName": "Apellidos",
  "Email": "Email",
  "Password": "Contraseña",
  "ConfirmPassword": "Confirmar contraseña",
  "PrivacyPolicy": "política de privacidad",
  "required": "Campo obligatorio",
  "Signup": "Regístrate",

  "*required": "*requerido",
  "InvalidEmail": "Dirección de correo electrónico inválida",
  "InvalidCharacters": "Contiene caracteres no válidos. Por favor, use solo letras, espacios, guiones (-), apóstrofes (') y puntos (.)",
  "UnableToAcceptInvitation": "No podrá aceptar la invitación con esta dirección de correo electrónico.",
  "PasswordMinLength": "La contraseña debe contener 6 caracteres como mínimo",
  "PasswordDoesNotMatch": "Las contraseñas no coinciden",

  "SignUpConsent1Part1": "Acepto el uso de cookies, la recopilación y el procesamiento de datos por parte de RebelBase, así como la transmisión de datos a Estados Unidos.",
  "SignUpConsent1Part2": "Para obtener detalles sobre cómo protegemos sus datos personales, consulte nuestra ",

  "Cookies": "Cookies",
  "CookiesConsent": "RebelBase utiliza las cookies para mantener las preferencias del usuario y mejorar su experiencia.",

  "DataCollection": "Recopilación y procesamiento de datos",
  "DataCollectionConsent": "RebelBase procesa los datos individuales para prestar sus servicios en la plataforma.",

  "DataTransmission": "Transmisión de datos a Estados Unidos",
  "DataTransmissionConsent": "RebelBase es una empresa estadounidense, por lo que para ofrecerles nuestros servicios, debemos transferir de forma segura los datos a Estados Unidos.",

  "forMoreInfo": "Para más información, consulta la",

  "SignUpConsent2": "Acepto recibir notificaciones promocionales de RebelBase por correo electrónico. RebelBase puede enviar a sus clientes actualizaciones por correo electrónico para solicitar opiniones a través de una encuesta o comunicaciones de marketing. No obstante, se puede cancelar la suscripción en cualquier momento.",
  "Optional": "Opcional",

  "agree": "Al registrarse, acepta nuestros ",
  "terms": "términos de servicio.",
  "signedUp?": "¿Ya te has registrado? ",
  "Login": "Iniciar sesión",
  "getStarted": "Empezar",

  "see": "Ver",

  "readMore": "Leer más",

  "EnterValidEmail": "Por favor introduce una dirección de correo electrónico válida."
}
